import axios from 'axios';
import { KpiRequests, KpiResponse } from '../interfaces/kpi';
import { PhotoRequestStatus } from '@homesusa/core';

const photoRequestsUrl = process.env.REACT_APP_API_PHOTO;
const gatewayUrl = process.env.REACT_APP_API_GATEWAY;

export const getKpiRequestsData = async (): Promise<KpiResponse<KpiRequests[]>> => {
  try {
    const response = await axios.get<KpiResponse<KpiRequests[]>>(
      `${gatewayUrl}/api/aggregator/request`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getKpiPhotoRequest = async (params?: {
  isOnlyCount: boolean;
  Status: PhotoRequestStatus;
}): Promise<KpiResponse<never[]>> => {
  const response = await axios.get<KpiResponse<never[]>>(
    `${photoRequestsUrl}api/photo-requests`,
    params ? { params } : undefined
  );
  return response.data;
};
